<template>
  <v-col cols="12" sm="12" class="pt-0">
      <v-card class="pa-3">
        <h4>Client Details</h4>
        <v-card-text>
          <h5>Client Name</h5>
          <h3 class="mb-2">{{ client.name }}</h3>
          <h5>Mobile No</h5>
          <h3 class="mb-2">{{ client.mobile }}</h3>
          <h5>Email</h5>
          <h3 class="mb-2">{{ client.email }}</h3>
          <h5>Gst</h5>
          <h3 class="mb-2">{{ client.gst }}</h3>
          <EditClient :clientid="client.id"/>
        </v-card-text>
      </v-card>
  <!-- <v-simple-table>
    <template v-slot:default>
          <thead>
              <tr>
              <th>Client Name</th>
              <th>Mobile No.</th>
              <th>Email</th>
              <th>Gst</th>
              <th>Action</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>{{ client.name }}</td>
                  <td>{{ client.mobile }}</td>
                  <td>{{ client.email }}</td>
                  <td>{{ client.gst }}</td>
                  <td><EditClient :clientid="client.id"/></td>
              </tr>
          </tbody>
    </template>
  </v-simple-table> -->
  </v-col>
</template>

<script>
import EditClient from './EditClient.vue';
  export default {
    props : {
        client : Object
    },
    components: {
      EditClient
    },
    data: () => ({
    }),
  }
</script>